import React, { useState, useEffect } from 'react';
import View from 'src/components/view';
import utils from 'src/components/utils';
import Element from 'src/components/element';
import CustomCarousel from 'src/components/carousel';
import MenuCarrinho from 'src/components/menu_carrinho';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import homeIcon from 'src/components/img/homeIcon.png';
import Card_produto from 'src/components/card_produto';

function Carrinho() {
  const path = window.location.pathname;
  const split = path.split('/');
  let idClassificacao = 0;

  if (split.length >= 3) {
    idClassificacao = parseInt(split[2]);
  }

  window.processo_atual = 73;

  let [view] = useState({});
  let [pedido, setPedido] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: { classificacao: idClassificacao } });
  let [homes, setHomes] = useState([]);
  let [ready, setReady] = useState(false);
  let [showDialog, setShowDialog] = useState(false);
  let [index, setIndex] = useState(0);
  let user = utils.getUser();
  let [banners] = useState({});
  let [barraPrococao, setBarraPrococao] = useState({ ativo: false, texto_exibicao: '', cor_barra: '' });

  crud.allow = function (key) {
    if (user.administrativo) {
      return true;
    }

    return window.access?.[key];
  };
  const carregarImagens = function (hp) {
    const _hc_ = {};

    _hc_.complete = function (res) {
      if (res.data) {
        hp.imagens = [];

        for (const i in res.data) {
          let im = res.data[i];
          let ps = im.posicao.toLowerCase();

          if (ps !== 'principal') {
            banners[ps] = im;
          } else {
            hp.imagens.push(im);
          }
        }
      }
    };
    _hc_.element = {};
    _hc_.cfg = {
      url:
        'listarBannerCatalogo?catalogo=' +
        hp.id +
        (idClassificacao && idClassificacao > 0 ? '&classificacao=' + idClassificacao : ''),
      method: 'GET',
    };

    _hc_.changed = { superior: 0 };
    _hc_.crud = crud;
    _hc_.view = view;

    utils.call(_hc_);
  };

  const checkBarraPromocao = function () {
    utils.execute(crud, 'encontrarConfigBarraPromocao', null, function (res) {
      if (res.data && res.data.length > 0) {
        barraPrococao = res.data[0];
        setBarraPrococao(barraPrococao);
      }
    });
  };

  useEffect(() => {
    if (!ready) {
      utils.execute(crud, 'encontrarPedido?id_pedido=0', null, function (res) {
        if (res.data && res.data.length > 0) {
          pedido = res.data[0];
          setPedido(res.data[0]);
          checkBarraPromocao();
        } else if (crud.allow('EDITAR_FILIAL') !== false) {
          showDialog = true;
          setShowDialog(true);
        }
      });

      setReady(true);

      const _hc_ = {};

      _hc_.complete = function (res) {
        if (res.data) {
          homes = res.data;
          setHomes(homes);

          for (const i in homes) {
            const hp = homes[i];

            carregarImagens(hp);
          }
        }
      };
      _hc_.element = {};
      _hc_.cfg = {
        url: 'listarHomeCatalogo',
        method: 'GET',
      };

      _hc_.changed = { superior: 0 };
      _hc_.crud = crud;
      _hc_.view = view;

      utils.call(_hc_);
    }
  }, []);

  crud.refresh = function () {
    setIndex(index + 1);
    setCrud(crud);
  };

  crud.open = function (value, args) {
    const click = value.click;
    const data = args.data;
    let d = {};
    let url = click.url;

    for (const i in data) {
      const v = data[i];
      const b = '{' + i + '}';
      const c = v + '';

      url = url.replace(b, c);
    }
    d.path = url;
    d.label = click.label;

    window.location.href = url;
  };

  crud.onClick = function (c) {
    crud.changed.classificacao = c.id;
    setCrud(crud);
  };

  const filial = {
    elements: {
      detail: {
        center: true,
        elements: {
          title: {
            value:
              '<i class="fas fa-store"></i>' +
              utils.lng('label_pergunta_retirar_produto_filial', 'Em qual filial você deseja retirar seu produto?'),
          },
          info: {
            value: utils.lng(
              'label_aviso_retirar_produto_filial',
              'Dessa forma você terá acesso aos produtos e ofertas da Filial selecionada.',
            ),
          },
        },
      },
      filialRet: {
        name: 'filialRetirada',
        label: utils.lng('filial_retirada', 'Filial retirada'),
        type: 'select',
        itemValue: 'id',
        itemLabel: 'nome',
        list: {
          url: 'Filial',
        },
      },
      label: {
        center: true,
        elements: {
          info: {
            rendered: utils.getPaisUser() !== 'BRA',
            value: utils.lng(
              'label_aviso_troca_pais',
              'Para comprar em uma filial de outro país, favor alterar o país na bandeirinha do menu',
            ),
          },
        },
      },
    },
  };

  const closeDialog = function (isRedirectHome) {
    showDialog = false;
    setShowDialog(false);
    if (isRedirectHome === true) {
      window.location.href = '/home';
    }
  };

  const confirmDialog = function () {
    let _ks_ = {};

    _ks_.global = true;
    _ks_.crud = crud;
    _ks_.changed = pedido;
    _ks_.element = {};

    _ks_.complete = function () {
      closeDialog();
    };

    _ks_.cfg = {
      redirect: true,
      url: 'cart/changeDeliveryLocal',
      method: 'POST',
      global: true,
    };
    utils.call(_ks_);
  };

  const expandHeader = function () {
    const uiCatalogo = document.getElementById('ui-catalogo');
    const uiCompressMenu = document.getElementById('ui-compress-menu');

    if (uiCatalogo && uiCompressMenu) {
      uiCatalogo.classList.remove('compacted-header');
      uiCompressMenu.classList.remove('compacted-header');
    }
  };

  return (
    <View name="carrinho">
      <div id="ui-catalogo" className="ui-catalogo">
        <Dialog
          open={showDialog}
          className="ui-dlg-escolha-filial"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Element disabled={false} value={filial} crud={crud} data={pedido} view={view}></Element>
          </DialogContent>
          <DialogActions>
            <Button
              id="btnFechar"
              onClick={() => {
                closeDialog(true);
              }}
              variant="contained"
              color="secondary"
            >
              {utils.lng('fechar', 'Fechar')}
            </Button>
            <Button id="btnConfirmarFilial" onClick={confirmDialog} variant="outlined" color="primary">
              {utils.lng('confirmar', 'Confirmar')}
            </Button>
          </DialogActions>
        </Dialog>

        <div id="ui-compress-menu" className="ui-compress-menu">
          <div className="carrinho-classe col-4">
            <div>
              <a href="/carrinho">
                <img src={homeIcon} className="homeIcon"></img>
              </a>
              <a href="/carrinho/favoritos" className="fav-classe">
                <svg
                  class="mt-2"
                  id="Grupo_22"
                  data-name="Grupo 22"
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.92"
                  height="22.796"
                  viewBox="0 0 26.92 22.796"
                >
                  <path
                    id="Caminho_80"
                    data-name="Caminho 80"
                    d="M19.665,39.221a7.038,7.038,0,0,0-5.677,2.888c-.2.252-.372.5-.527.748-.155-.244-.331-.5-.527-.748a7.038,7.038,0,0,0-5.677-2.888C3.026,39.221,0,42.763,0,47.013c0,4.86,3.983,9.44,12.915,14.851a1.052,1.052,0,0,0,1.09,0c8.932-5.411,12.915-9.991,12.915-14.851C26.92,42.765,23.9,39.221,19.665,39.221Zm2.374,13.844a39.145,39.145,0,0,1-8.579,6.668,39.147,39.147,0,0,1-8.579-6.668C3.012,50.979,2.1,49,2.1,47.013c0-3.06,2.068-5.689,5.153-5.689a4.928,4.928,0,0,1,3.981,2.03,7.811,7.811,0,0,1,1.219,2.2,1.052,1.052,0,0,0,2.008,0A7.8,7.8,0,0,1,15.645,43.4a4.941,4.941,0,0,1,4.019-2.079c3.088,0,5.153,2.632,5.153,5.689C24.817,49,23.908,50.979,22.039,53.065Z"
                    transform="translate(0 -39.221)"
                    fill="#ff002f"
                  ></path>
                </svg>
              </a>
              <button
                className="btn btn-danger"
                onClick={function () {
                  window.location.href = '/carrinho/pedido';
                }}
              >
                <svg
                  className="cart-ico-classe"
                  xmlns="http://www.w3.org/2000/svg"
                  height="23"
                  viewBox="0 0 29.977 28.213"
                >
                  <path
                    data-name="icon-carrinho"
                    fill="#ffffff"
                    d="M29.8,18.529a.961.961,0,0,0-.748-.411l-18.595-.8a.962.962,0,0,0-.083,1.922l17.336.747L24.306,30.621H9.137L6.4,15.7a.962.962,0,0,0-.594-.721L1.314,13.215a.962.962,0,1,0-.7,1.791L4.6,16.573,7.39,31.757a.962.962,0,0,0,.946.788H8.8L7.742,35.479A.8.8,0,0,0,8.5,36.552h.741a2.885,2.885,0,1,0,4.289,0h6.291a2.885,2.885,0,1,0,4.289,0h.9a.8.8,0,1,0,0-1.6H9.637l.866-2.4H25.007a.961.961,0,0,0,.916-.668l4.008-12.5A.96.96,0,0,0,29.8,18.529ZM11.382,39.758a1.282,1.282,0,1,1,1.282-1.282A1.284,1.284,0,0,1,11.382,39.758Zm10.58,0a1.282,1.282,0,1,1,1.282-1.282A1.284,1.284,0,0,1,21.961,39.758Z"
                    transform="translate(0 -13.148)"
                  ></path>
                </svg>

                <font className="cart-label-classe">{utils.lng('meu_carrinho', 'Meu carrinho')}</font>
              </button>
            </div>

            <button className="btn-compact-header" onClick={() => expandHeader()}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path
                  fill="#ff002f"
                  d="M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 402.7 329.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 210.7 329.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
                />
              </svg>
            </button>
          </div>
        </div>
        {barraPrococao && barraPrococao.ativo && (
          <div
            className="ui-catalogo-barra-promocao ui-catalogo-barra-promocao-carrinho"
            style={{
              backgroundColor: barraPrococao.cor_barra ? barraPrococao.cor_barra : '#F00',
              color: barraPrococao.cor_caracteres ? barraPrococao.cor_caracteres : '#FFF',
            }}
          >
            <span>{barraPrococao.texto_exibicao}</span>
          </div>
        )}

        <MenuCarrinho crud={crud} view={view}></MenuCarrinho>

        {banners.esquerda && (
          <div className="ui-banner-lateral ui-banner-esquerda">
            <a href={banners.esquerda.link_redirecionamento}>
              <img src={banners.esquerda.link_banner}></img>
            </a>
          </div>
        )}
        <div id="ui-catalogo-content" className="ui-catalogo-content">
          <div className="ui-catalogo-home">
            {homes.map((i) => (
              <div className="ui-catalogo-bloco">
                <div className="ui-catalogo-banner">
                  {i.imagens && (
                    <Carousel infiniteLoop={false} autoPlay={true} showStatus={false} showArrows={true}>
                      {i.imagens.map((li) => (
                        <>
                          {li.posicao === 'PRINCIPAL' && (
                            <div className="ui-banner-principal">
                              <a href={li.link_redirecionamento}>
                                <div>
                                  <img src={li.link_banner} />
                                </div>
                              </a>
                            </div>
                          )}
                        </>
                      ))}
                    </Carousel>
                  )}
                </div>
                <CustomCarousel classificacao={idClassificacao} data={i} crud={crud} view={view} />
              </div>
            ))}
          </div>

          <div className="ui-catalogo-data">
            <Card_produto classificacao={idClassificacao} crud={crud} />
          </div>
        </div>
        {banners.direita && (
          <div className="ui-banner-lateral ui-banner-direita">
            <a href={banners.direita.link_redirecionamento}>
              <img src={banners.direita.link_banner}></img>
            </a>
          </div>
        )}
      </div>
    </View>
  );
}

export default Carrinho;
